import { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';

// Components
import Loader from 'components/Loader';
import FailureAlert from 'components/FailureAlert';
import Modal from 'components/CncUI/Modal';
// Utilities
import Logger from 'utilities/logger';

const useStyles = makeStyles(theme => ({
  dialog: {
    maxWidth: '90vw',
  },
  container: {
    minWidth: '30vw',
  },
  button: {
    margin: theme.spacing(1.5),
  },
}));

const ImageViewer = ({ url, fileFetcher, config, onClose, loaderMessage }) => {
  const classes = useStyles();
  const logger = Logger('ImageViewer');
  const [state, setState] = useState({
    loading: true,
    url: null,
    error: null,
  });
  const modify = data => setState(old => ({ ...old, ...data }));

  useEffect(() => {
    if (url) {
      modify({ url, loading: false });
      return;
    }
    async function fetchData() {
      try {
        const url = await fileFetcher(config);
        modify({ url, loading: false });
      } catch (error) {
        modify({ error, loading: false });
        logger.error(error);
      }
    }
    fetchData();
  }, []);

  return (
    <Modal
      open={true}
      onClose={onClose}
      scroll={'paper'}
      aria-label="ImageViewer-loader"
      data-test-id={`ImageViewer-root`}
      classes={{ paper: classes.dialog }}
    >
      <Modal.Content>
        {state.loading && (
          <Loader
            message={
              loaderMessage ||
              'Please wait a moment while we get this file from our secure storage...'
            }
          />
        )}
        {(state.error || (!state.loading && !state.url)) && <FailureAlert />}
        {state.url && <img src={state.url} alt="your preview" />}
      </Modal.Content>
    </Modal>
  );
};

export default ImageViewer;
